import { Component, OnInit, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { BookletDialogComponent } from "@shared/dialogs/booklet-dialog/booklet-dialog.component";
import { UserDTO } from "@shared/model/user.model";
import { UsersService } from "@shared/services/users/users.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";

@Component({
	selector: "app-faq",
	templateUrl: "./faq.component.html",
	styleUrl: "./faq.component.scss",
	standalone: false
})
export class FaqComponent implements OnInit {
	private userService = inject(UsersService);
	protected utils = inject(ClickarUtilsService);
	private dialog = inject(MatDialog);

	user: UserDTO;
	dialogConfig = new MatDialogConfig();

	ngOnInit() {
		this.userService.getProfileOfLoggedUser().subscribe(value => {
			this.user = value;
		});
	}

	openBooklet() {
		this.dialogConfig.width = '500px';
		this.dialog.open(
			BookletDialogComponent,
			this.dialogConfig
		);
	}
}